import {
  Rating,
  styled,
  Tooltip,
  tooltipClasses,
  Typography,
} from "@mui/material";
const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 500,
  },
});
export const userColumns = [
  { field: "id", headerName: "UID", width: 240, sortable: false },
  {
    field: "user",
    headerName: "User",
    width: 230,
    renderCell: (params) => {
      return (
        <div className="cellWithImg">
          <img className="cellImg" src={params.row.user_photo} alt="avatar" />
          {params.row.user_name}
        </div>
      );
    },
    sortable: false,
  },
  {
    field: "email",
    headerName: "Email",
    width: 230,
    renderCell: (params) => {
      return <div>{params.row.user_email}</div>;
    },
    sortable: false,
  },
  {
    field: "mobile_number",
    headerName: "Mobile Number",
    width: 160,
    renderCell: (params) => {
      return <div>{"+91" + params.row.mobile_number}</div>;
    },
    sortable: false,
  },
];
export const publisherColumns = [
  { field: "id", headerName: "UID", width: 240, sortable: false },
  {
    field: "user",
    headerName: "User",
    width: 230,
    renderCell: (params) => {
      return <div className="cellWithImg">{params.row.fullName}</div>;
    },
    sortable: false,
  },
  {
    field: "email",
    headerName: "Email",
    width: 230,
    renderCell: (params) => {
      return <div>{params.row.emailAddress}</div>;
    },
    sortable: false,
  },
  {
    field: "mobile_number",
    headerName: "Mobile Number",
    width: 160,
    renderCell: (params) => {
      return <div>{"+91" + params.row.phoneNumber}</div>;
    },
    sortable: false,
  },
];
export const ordersColumns = [
  { field: "id", headerName: "Unique ID", width: 240, sortable: false },
  {
    field: "product",
    headerName: "Product",
    width: 230,
    renderCell: (params) => {
      return (
        <div className="cellWithSquareImg">
          <img className="cellImg" src={params.row.thumbImage} />
          {params.row.name}
        </div>
      );
    },
    sortable: false,
  },
  {
    field: "userid",
    headerName: "User ID",
    width: 230,
    renderCell: (params) => {
      return <div>{params.row.userId}</div>;
    },
    sortable: false,
  },
  {
    field: "paymentid",
    headerName: "Transaction ID",
    width: 160,
    renderCell: (params) => {
      return <div>{params.row.payment_UID}</div>;
    },
    sortable: false,
  },
];

export const booksColumns = [
  { field: "id", headerName: "ID", width: 190, sortable: false },
  {
    field: "product",
    headerName: "Product",
    width: 250,
    innerHeight: 50,
    renderCell: (params) => {
      return (
        <div className="cellWithSquareImg">
          <img className="cellImg" src={params.row.thumbImage} />
          {params.row.name}
        </div>
      );
    },
    sortable: false,
  },
  {
    field: "amount",
    headerName: "Price",
    width: 100,
    align: "right",
    headerAlign: "right",
    headerAlign: "right",
    renderCell: (params) => {
      return (
        <div>
          {params.row.payment_type === "Paid"
            ? `₹${Math.ceil(
                params.row.price -
                  (params.row.price / 100) * params.row.discount
              )}`
            : "Free"}
        </div>
      );
    },
    sortable: false,
  },
  {
    field: "discount",
    headerName: "Discount(%)",
    width: 120,
    align: "right",
    headerAlign: "right",
    renderCell: (params) => {
      return (
        <div>
          {params.row.payment_type === "Paid"
            ? params.row.discount
            : "Not Applicable"}
        </div>
      );
    },
    sortable: false,
  },
  {
    field: "unitSold",
    headerName: "Unit Sold",
    width: 100,
    align: "right",
    headerAlign: "right",
    renderCell: (params) => {
      return <div>{params.row.unitSold}</div>;
    },
    sortable: false,
  },
];

export const reviewColumn = [
  { field: "id", headerName: "Review ID", width: 190, sortable: false },
  {
    field: "rating",
    headerName: "Rating",
    width: 150,
    innerHeight: 50,
    renderCell: (params) => {
      return (
        <div>
          <Rating name="read-only" value={params.row.rating} readOnly />
        </div>
      );
    },
    sortable: false,
  },
  {
    field: "review",
    headerName: "Review",
    width: 550,
    renderCell: (params) => {
      return (
        <div>
          {params.row.review_text.length != 0 && (
            <div>
              <CustomWidthTooltip
                title={params.row.review_text}
                placement="bottom-start"
              >
                <Typography sx={{ cursor: "pointer" }}>
                  {" "}
                  {params.row.review_text}
                </Typography>
              </CustomWidthTooltip>
            </div>
          )}
          {params.row.review_text.length == 0 && (
            <div>No Review only rating</div>
          )}
        </div>
      );
    },
    sortable: false,
  },
  {
    field: "user_id",
    headerName: "User ID",
    width: 100,
    renderCell: (params) => {
      return (
        <div>
          {" "}
          <a
            href={"/users/" + params.row.user_id}
            target="_blank"
            style={{ textDecoration: "none" }}
          >
            View User 
          </a>
        </div>
      );
    },
    sortable: false,
  },
  {
    field: "product_id",
    headerName: "Book ID",
    width: 100,
    renderCell: (params) => {
      return (
        <div>
          {" "}
          <a
            href={"/library/" + params.row.product_id}
            target="_blank"
            style={{ textDecoration: "none" }}
          >
            View Book 
          </a>
        </div>
      );
    },
    sortable: false,
  },

  {
    field: "timestamp",
    headerName: "Date & Time",
    width: 200,

    renderCell: (params) => {
      return <div>{params.row.timestamp.toDate().toLocaleString()}</div>;
    },
    sortable: false,
  },
];
